import { Skeleton } from './Skeleton';

interface LoadingStateProps {
  readonly title?: string;
  readonly variant?: 'inline' | 'page';
}

/**
 * Generic loading skeleton matching the shell.css `.state-loading` pattern.
 * `variant="page"` lays out a heading + grid + table-stub skeleton; `inline`
 * renders only the small heading skeleton for in-section loading.
 */
export function LoadingState({ title = 'جاري التحميل…', variant = 'page' }: LoadingStateProps) {
  if (variant === 'inline') {
    return (
      <div role="status" aria-live="polite" style={{ padding: '12px 0' }}>
        <span className="lbl" style={{ display: 'block', marginBottom: 8 }}>
          {title}
        </span>
        <Skeleton height={14} width="60%" />
      </div>
    );
  }
  return (
    <div
      role="status"
      aria-live="polite"
      style={{ display: 'flex', flexDirection: 'column', gap: 12 }}
    >
      <Skeleton height={24} width="40%" />
      <Skeleton height={14} width="65%" />
      <div
        style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginTop: 8 }}
      >
        <Skeleton height={92} />
        <Skeleton height={92} />
        <Skeleton height={92} />
      </div>
      <Skeleton height={180} />
    </div>
  );
}
